export const INITIAL_COORDINATES = [
  { lat: 26.278105058220238, lng: -81.92446166463473 },
  { lat: 26.109060322769867, lng: -81.90733520037675 },
  { lat: 25.85246588510246, lng: -81.80457641482877 },
  { lat: 25.63134821377279, lng: -81.56195150450719 },
  { lat: 25.546391699370915, lng: -81.41923096902391 },
  { lat: 25.327287176428257, lng: -81.28507363650067 },
  { lat: 25.169802474867645, lng: -81.22798542230736 },
  { lat: 24.887888856768075, lng: -80.98536051198577 },
  { lat: 24.719467891619924, lng: -80.7512988337932 },
  { lat: 24.820547930670152, lng: -80.48012981637497 },
  { lat: 25.043150810256645, lng: -80.0690946741831 },
  { lat: 25.26018751432934, lng: -80.04055056708646 },
  { lat: 25.417554934469173, lng: -80.02913292424778 },
  { lat: 25.862740389568604, lng: -79.96633588863514 },
  { lat: 26.239707339449847, lng: -79.96062706721581 },
  { lat: 26.60524749734164, lng: -79.89783003160316 }
];

export const GOOGLE_MAPS_API_KEY = 'AIzaSyB2UgyfKbhOovgh3NjOPku9LRCia8VwS8A';

export const MAP_STYLES = {
  polylineOptions: {
    strokeColor: '#22c55e',
    strokeOpacity: 0.7,
    strokeWeight: 3,
  },
  markerOptions: {
    fillColor: '#22c55e',
    fillOpacity: 1,
    strokeColor: '#16a34a',
    strokeWeight: 2,
    scale: 8,
  }
};
